/* src/app/features/habilitacao/select-cotista/select-cotista.component.scss */
.ng-select.ng-select-single .ng-select-container {
  border-radius: 0px !important;
}
.ng-select {
  height: 38px !important;
}
/*# sourceMappingURL=select-cotista.component.css.map */
